import {useEffect, useMemo} from "react"
import {Link, useHistory} from "react-router-dom"
import Avatar from "@components/avatar"
import {
    List,
    CheckCircle,
    XCircle,
    AlertCircle
} from "react-feather"
import {
    Button,
    Row,
    Col,
    Spinner,
    Badge
} from "reactstrap"
import img4 from "@src/assets/images/avatars/avatar-blank.png"
import {useSelector, useDispatch} from "react-redux"
import CustomPagination from '@src/views/components/pagination/CustomPagination'
import queryString from "query-string"
import {campaignListing} from "@store/actions/RDActions"

import { OutreachAvailabilityBadge, OutreachActionButton } from "@src/views/components/outreach/OutreachCardElements"

// ─── Reusable: Spots Left / Full Badge ────────────────────────────────────────
const CampaignListing = () => {
    const history = useHistory()
    const dispatch = useDispatch()

    const {
        campaignListingLoading,
        campaignListingData,
        campaignListingError
    } = useSelector((store) => store.rdReducer)

    const {data, pages} = useMemo(() => {
        return {
            data: campaignListingData?.data ?? null,
            pages: campaignListingData?.pages ?? null
        }
    }, [campaignListingData])

    useEffect(() => {
        const parsed = queryString.parseUrl(window.location.href)
        const pageNo = parsed?.query?.page
        let params = ''
        if (pageNo) {
            params = `?page=${pageNo}`
        }
        dispatch(campaignListing(params))
    }, [])

    const handleCustomPagination = (pageUrl) => {
        const parsed = queryString.parseUrl(pageUrl)
        const pageNo = parsed?.query?.page
        const params = `?page=${pageNo}`
        dispatch(campaignListing(params))
        history.push({
            pathname: window.location.pathname,
            search: `?page=${pageNo}`
        })
    }

    const getAppliedCampaignData = (data) => {
        history.push(`/rd/apply-on-campaign/${data?.id}/view`)
    }

    return (
        campaignListingLoading ? (
            <div className='bg-primary text-white text-center p-1'>
                <Spinner style={{width: '18px', height: '18px'}}/> Please wait...
            </div>
        ) : (data ? (
            <>
                <Row>
                    {data?.map((campaign, index) => {
                        const isFull = Boolean(campaign?.is_full) || campaign?.spots_left === 0
                        return (
                            <Col md="4" className="mb-4" key={`campaign-${index}`}>
                                <div
                                    className="brandContent text-center p-3 h-100 d-flex flex-column justify-content-between"
                                    style={{
                                        position: 'relative',
                                        opacity: isFull ? 0.7 : 1,
                                        backgroundColor: '#ffffff',
                                        border: '1px solid #EAEAEA',
                                        borderRadius: '16px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.03)'
                                    }}
                                >
                                    {/* ── Availability Badge (Pill shape with colored dot) ── */}
                                    <OutreachAvailabilityBadge
                                        isFull={isFull}
                                        spotsLeft={campaign?.spots_left}
                                    />

                                    <div className="d-flex flex-column align-items-center w-100">
                                        <Avatar
                                            img={campaign?.brand_img || img4}
                                            imgHeight="72"
                                            imgWidth="72"
                                            className='avatar-img-fit-contain mt-1 mb-2'
                                        />
                                        <h4
                                            className="text-break font-weight-bold text-center mb-2"
                                            title={campaign?.campaign_title}
                                            style={{color: "#111111", fontSize: "16px", lineHeight: "1.3"}}
                                        >
                                            {campaign?.campaign_title?.length > 40 ? `${campaign?.campaign_title.substring(0, 40)}...` : campaign?.campaign_title}
                                        </h4>
                                        <div className="w-100 mb-2" style={{backgroundColor: "#F8F9FA", borderRadius: "8px", padding: "8px 12px"}}>
                                            <p className="cursor-pointer text-center m-0" style={{color: "#666666", fontSize: "14px", fontWeight: 500}}>
                                                {campaign?.brand_name}
                                            </p>
                                        </div>
                                    </div>

                                    {/* ── CTA Action Button ──────────────────────── */}
                                    <div className="w-100 mt-1">
                                        <OutreachActionButton
                                            campaign={campaign}
                                            onViewApplied={getAppliedCampaignData}
                                        />
                                    </div>
                                </div>
                            </Col>
                        )
                    })}
                </Row>
                <Row className="pt-4 justify-content-centered">
                    <Col md="12">
                        <CustomPagination pageLinks={pages}
                                          onPaginationClick={handleCustomPagination}
                        />
                    </Col>
                </Row>
            </>
        ) : (
            <div className='font-weight-bold text-center'>
                <div className='mb-1'>Sorry! Outreach not found.</div>
                <Link className='text-primary' to='/dashboard/rd/campaigns'>Go Back</Link>
            </div>
        )))
}

export default CampaignListing
